import React from 'react';
import { Link } from 'react-router-dom';
import WOW from 'wowjs';
import getAppConfig  from '../../config/AppConfig';

class About extends React.Component {
    componentDidMount() {
        new WOW.WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 20,
            mobile:       true,
            live:         true,
        }).init();
    }

    
    render() {

        const siteUrl = getAppConfig("siteUrl");

        return (
            <section id="about" className="repair-about-area ptb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="repair-about-content">
                                <div className="section-title">
                                    <span>About Us</span>
                                    <h3>We provide tools to help with organizing various events or functions</h3>
                                    <p>We take pride knowing our tools makes it easier, more enjoyable, and less stressful to organize that special event/function you have in mind.</p>
                                </div>

                                <ul>
                                    <li><i className="icofont-calendar"></i> Create Event in Minutes</li>
                                    <li><i className="icofont-handshake-deal"></i> Simple Stepwise Process</li>
                                    <li><i className="icofont-users"></i> Add People in a Snap</li>
                                    <li><i className="icofont-mouse"></i> Pitch In with One Click </li>
                                </ul>

                                <p><i>Take advantage of our simple tools to organize, plan, bring people together, and make things happen. It all starts with you.</i></p>

                               {/*  <Link to="/about-us" className="read-more-btn">Read More About Us</Link> */}
                                <a className="read-more-btn"  href={`${siteUrl}/resources/about-us`}>Read More About Us</a>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="repair-about-image">
                            {/*     <img src={require('../../assets/img/about1.jpg')} className="wow fadeInDown" alt="box" />
                                <img src={require('../../assets/img/about2.jpg')} className="wow zoomIn" alt="box" />
                                <img src={require('../../assets/img/about3.jpg')} className="wow fadeInUp" alt="box" />
                                */ }
                                <img src="images/outdoor-bbq-small.jpg" className="wow fadeInDown" alt="box" />
                                <img src="images/young-volunteers-sm.jpg" className="wow zoomIn" alt="box"   />
                                <img src="images/potluck-event.jpg" className="wow fadeInUp" alt="box" height="54%"  />
                                <img src={require('../../assets/img/about-shape1.png')} alt="box" />
                                <img src={require('../../assets/img/about-shape2.png')} alt="box" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default About;


// WEBPACK FOOTER //
// ./src/components/versionSeven/About.js